<template>
  <div class="">
    <template v-for="(city, cityIndex) in cities">
      <NuxtLink
        :key="city.seoName"
        :to="
          localePath({
            name: 'professionals',
            params: { profession: profession.seoName, city: city.seoName },
          })
        "
        :class="{
          'text-2xl text-primary-dark': city.population > 10000,
          'text-xl text-primary':
            city.population <= 10000 && city.population > 4000,
          'text-base text-primary-light':
            city.population <= 4000 && city.population > 1000,
          'text-xs text-primary-lighter': city.population <= 1000,
        }"
      >
        {{ city.name }} {{ Math.min(city.population / 1000) }}
        {{ profession.name
        }}<span v-if="cityIndex !== cities.length - 1">, </span>
      </NuxtLink>
      <!-- TODO as it stands this code is never reached because there is a clash in URLs, seo-name of capital is the same the county,
       and this component is only used on professional pages where city seo_name takes precedence -->
      <template v-if="isCapital(city)">
        (<template v-for="(part, partIndex) in cityParts">
          <NuxtLink
            :key="`${city.seoName}${part.seoName}`"
            :to="
              localePath({
                name: 'professionalsParentCity',
                params: {
                  profession: profession.seoName,
                  parentCity: city.seoName,
                  city: part.seoName,
                },
              })
            "
          >
            {{ part.name }} {{ part.population }} {{ profession.name
            }}<span v-if="partIndex !== cityParts.length - 1">, </span>
          </NuxtLink>
        </template>
        ),
      </template>
    </template>
  </div>
</template>

<script>
import useCapital from "~/composables/useCapital";
export default {
  props: {
    profession: {
      type: Object,
      required: true,
    },
    cities: {
      type: Array,
      required: true,
    },
    cityParts: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { isCapital } = useCapital();
    return {
      isCapital,
    };
  },
};
</script>
